import { BaseModel } from '../../../shared/base/base.models';

export class ExceptionLog extends BaseModel {
    type: ExceptionLogType;
    className: string;
    url: string;
    description: string;
    causeDescription: string;
    requestBody: string;
    stackTrace: StackTrace[];
    queryParameters: string[];

    // User for form
    loggedUser: string;
    loggedUserName: string;
    loggedUserLegalEntity: string;
    loggedUserLegalEntityName: string;

    // Used for view
    requestParams: string;
}

export enum ExceptionLogType {
    IGNORE,
    IN_PROGRESS,
    RESOLVED
}

export class StackTrace {
    ordinal: number;
    stack: string;

    constructor(ordinal: number, stack: string) {
        this.ordinal = ordinal;
        this.stack = stack;
    }
}